'use client';

import { createContext } from 'react';

import type { MenuFloatingContextInterface } from '../types/use-menu.types';

export const MenuFloatingContext = createContext({} as MenuFloatingContextInterface);

MenuFloatingContext.displayName = 'Menu.Floating.Context';
